<script setup lang="ts">
import type { RouteRecordRaw } from "vue-router"
import { computed } from "vue"
import { useRoute, useRouter } from "vue-router"

const props = defineProps<{ routeList: RouteRecordRaw[] }>()
const route = useRoute()
const router = useRouter()
const sections = computed(() => props.routeList.filter(item => !item.meta?.hideInLevelTwoTabs))
const current = computed(() => sections.value.filter(item => route.path === item.path || route.path.startsWith(`${item.path}/`)).sort((a, b) => b.path.length - a.path.length)[0]?.path)
const isLanding = computed(() => route.path.endsWith("/index"))
const open = async (path: string | number) => {
  if (path !== current.value) await router.push(String(path))
}
</script>

<template>
  <Container class="store-section">
    <div v-if="!isLanding" class="store-section__nav"><NavBack :isBack="true" :showTitle="false" /></div>
    <div v-else-if="sections.length > 1" class="store-section__nav">
      <template v-if="sections.length > 5">
        <span class="store-section__label">切换报表</span>
        <el-select :model-value="current" filterable aria-label="切换报表" class="store-section__select" @change="open">
          <el-option v-for="item in sections" :key="item.path" :value="item.path" :label="String(item.meta?.title || '')" />
        </el-select>
      </template>
      <el-tabs v-else :model-value="current" @tab-change="open">
        <el-tab-pane v-for="item in sections" :key="item.path" :name="item.path" :label="String(item.meta?.title || '')" />
      </el-tabs>
    </div>
    <div class="store-section__body"><router-view /></div>
  </Container>
</template>

<style scoped lang="scss">
.store-section {
  padding: 0;

  &__nav {
    padding: 12px 24px 0;
  }

  &__label {
    margin-right: 12px;
    color: var(--el-text-color-secondary);
  }

  &__select {
    width: 260px;
    margin-bottom: 12px;
  }

  &__body {
    flex: 1;
    min-height: 0;
    overflow: auto;
  }

  :deep(.el-tabs__header) {
    margin-bottom: 0;
  }
}
</style>
